const styles = `:host {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  display: flex;
  align-items: flex-start;
  flex-grow: 1;
  font: var(--goto-body-medium);
  border-color: var(--goto-ui-05);
  border-width: 4px;
  min-height: 60px;
  color: var(--goto-neutral);
}
:host .badge {
  font: var(--goto-caption-default-01);
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--goto-ui-05);
  border-radius: 10px;
  min-width: 20px;
  min-height: 20px;
}
:host .step-text {
  overflow: hidden;
  line-height: 19px;
}
:host .badge,
:host .step-text {
  margin: 2px 10px 0 0;
}
:host .step-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host .step-description {
  font: var(--goto-caption-default-01);
  display: -webkit-box;
  word-wrap: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  color: var(--goto-text-02);
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

:host([selected]),
:host([variant=success]) {
  --goto-icon-color: design-token(icon-05);
  border-color: var(--goto-interactive-01);
}
:host([selected]) .badge,
:host([variant=success]) .badge {
  color: var(--goto-icon-05);
  background-color: var(--goto-interactive-01);
}

:host([variant=danger]) {
  --goto-icon-color: design-token(danger-01);
  color: var(--goto-danger-01);
}
:host([variant=danger]) .badge {
  color: inherit;
  background: none;
}
:host([variant=danger]) .step-description {
  color: var(--goto-danger-01);
}

:host([selected][variant=danger]) {
  border-color: var(--goto-danger-01);
}

:host([disabled]) {
  --goto-icon-color: design-token(disabled-04);
  color: var(--goto-disabled-04);
  border-color: var(--goto-disabled-02);
}
:host([disabled]) .badge,
:host([disabled]) .step-description {
  color: inherit;
}
:host([disabled]) .badge {
  background-color: var(--goto-ui-05);
}`; export default styles;